import { Box, Flex, Panel, Text } from 'components'
import { useWorkspace } from 'components/providers'
import { generatePath, useNavigate } from 'react-router'
import { useBreakpoint } from 'utils'
import { useTemplates } from 'utils/templateUtils'
import TemplateTileViewer from '../components/TemplateTileViewer'
import { RoutePath } from '../utils/routing'

export default function TemplatesPage() {
  const { workspace } = useWorkspace()
  const navigate = useNavigate()
  const { templates } = useTemplates()
  const isMobile = useBreakpoint() < 1
  const breakpoint = useBreakpoint()

  return (
    <Flex
      direction="column"
      gap={4}
      flex="auto"
      p={isMobile ? 4 : 0}
      pb={3}
      overflowY="auto"
      overflowX="hidden"
    >
      <Text textStyle="h3" pt={2}>
        Templates
      </Text>
      <Flex direction="column" gap={2} overflowY="auto" pr={5}>
        {breakpoint > 3 && (
          <Flex width="100%" pl={2} gap={3}>
            <Text {...headingTextProps} flex={1}>
              Title
            </Text>
            <Flex align="center" gap={3} flexShrink={0}>
              <Text {...headingTextProps} width="200px">
                Created By
              </Text>
              <Text {...headingTextProps} width="200px">
                Updated By
              </Text>
              <Text {...headingTextProps} width="120px">
                Last Updated
              </Text>
              <Box width="50px" flexShrink={0} />
            </Flex>
          </Flex>
        )}
        {templates?.map(template => (
          <Panel key={template.id} flex={1} p={4} gap={6} width="auto">
            <TemplateTileViewer
              template={template}
              onEdit={() =>
                navigate(
                  generatePath(RoutePath.TemplateInfo, {
                    workspaceId: workspace!.id,
                    id: template.id,
                  })
                )
              }
            />
          </Panel>
        ))}
      </Flex>
    </Flex>
  )
}

const headingTextProps = {
  textStyle: 'bodySmall' as const,
}
